export default __webpack_public_path__ + "static/media/1-cloudxier-shooper-highlight01.41f2926e.JPEG";